import { useState, useEffect } from 'react'
import { isEmail } from '@sainsburys-tech/bolt-validators'

const sanitiseString = str => str.replace(/[^a-z0-9!@?\s.,_-]/gim, '')

export default function useWriteReview() {
  const formFields = {
    overallRating: null,
    overallRatingError: '',
    reviewTitle: '',
    review: '',
    reviewError: '',
    reviewDirty: false,
    recommended: '',
    fit: 2,
    quality: null,
    comfort: null,
    value: null,
    age: '',
    nickname: '',
    nicknameError: '',
    email: '',
    emailError: '',
    termsAndConditions: false,
    termsAndConditionsError: '',
    photos: []
  }
  const [formData, setFormData] = useState(formFields)

  const setInput = formField => event => {
    const value = sanitiseString(event.target.value)
    setFormData({ ...formData, [formField]: value })
  }

  const setCheckbox = formField => () => {
    const value = !formData[formField]
    if (value) {
      setFormData({ ...formData, [formField]: value, [`${formField}Error`]: '' })
    } else {
      setFormData({
        ...formData,
        [formField]: value,
        [`${formField}Error`]: 'Please agree to the terms & conditions to submit your review'
      })
    }
  }

  const validateInput = formField => () => {
    const value = typeof formData[formField] === 'string' ? formData[formField].trim() : formData[formField]
    switch (formField) {
      case 'overallRating':
        if (!value) {
          setFormData({
            ...formData,
            [`${formField}Error`]: 'Please add an overall rating'
          })
        } else {
          setFormData({ ...formData, [`${formField}Error`]: '' })
        }
        break
      case 'review':
        if (!value || value.length < 20) {
          setFormData({
            ...formData,
            [`${formField}Error`]: `Please enter your review`,
            ...(!formData[`${formField}Dirty`] && { [`${formField}Dirty`]: true })
          })
        } else {
          setFormData({
            ...formData,
            [`${formField}Error`]: '',
            ...(!formData[`${formField}Dirty`] && { [`${formField}Dirty`]: true })
          })
        }
        break
      case 'nickname':
        if (!value || value.length < 2) {
          setFormData({
            ...formData,
            [`${formField}Error`]: 'Please enter a nickname'
          })
        } else {
          setFormData({ ...formData, [`${formField}Error`]: '' })
        }
        break
      case 'email':
        if (!isEmail(value)) {
          setFormData({
            ...formData,
            [`${formField}Error`]: 'Please enter an email address'
          })
        } else {
          setFormData({ ...formData, [`${formField}Error`]: '' })
        }
        break

      default:
        break
    }
  }

  const onRatingChange = formField => rating => {
    setFormData({ ...formData, [formField]: rating })
  }

  const onAddPhoto = event => {
    if (formData.photos.length >= 6) {
      return
    }
    const [photo] = event.target.files
    photo.imgSrc = URL.createObjectURL(photo)
    // Generate a random ID using epoch number
    photo.id = Date.now()
    setFormData({ ...formData, photos: [...formData.photos, photo] })
  }

  const onRemovePhotoClick = id => () => {
    setFormData({ ...formData, photos: [...formData.photos.filter(photo => photo.id !== id)] })
  }

  useEffect(() => {
    // Validate "review" if the field is dirty
    if (formData.reviewDirty) {
      validateInput('review')()
    }
  }, [formData.review])

  return { formData, setInput, setCheckbox, validateInput, onRatingChange, onAddPhoto, onRemovePhotoClick }
}
